module.exports = __webpack_public_path__ + "img/services_img_1.23fc2994.png";